// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1WpQ4","consentsList":"PatientConsents_consentsList__1ogYm","consentsListEmpty":"PatientConsents_consentsListEmpty__aUQwr"};